import { Dialog as SheetPrimitive } from '@base-ui/react/dialog';
import { cn } from '@/shared/lib/cn';

export function SheetTitle({ className, ...props }: SheetPrimitive.Title.Props) {
  return (
    <SheetPrimitive.Title
      data-slot="sheet-title"
      className={cn('text-base font-medium text-foreground', className)}
      {...props}
    />
  );
}
